import { floodFill } from "../../../ui/helpers";
import { setScene } from "../../../ui/scene";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { GameScene } from "../../scenes/game";
import { HelpComponent } from "./helpComponent";

export const HomeComponent: ComponentF<void> = (C) => {
  floodFill(C.display, { x: 8, y: 0, h: C.bounds.h, w: 4 }, Colors.B_GREY_1);
  floodFill(C.display, { x: 0, y: 7, h: 3, w: C.bounds.w }, Colors.B_GREY_1);

  C.display.drawText(
    C.bounds.x + 12,
    C.bounds.y + 8,
    `%b{${Colors.B_GREY_1}}Pieux`,
    16
  );

  C.display.drawText(
    C.bounds.x + C.bounds.w / 2 - 9,
    C.bounds.y + C.bounds.h - 2,
    `%c{${Colors.RED_4}}Enter%c{} - Start Game`
  );

  C.handlers.keypress = (key) => {
    if (key === "Enter") {
      setScene(new GameScene());
      return true;
    }
    return false;
  };

  return [
    createElement(HelpComponent, {
      x: 14,
      y: 12,
      w: C.bounds.w - 14,
      h: C.bounds.h - 10,
    }),
  ];
};
